





































































































































































import Vue from 'vue';

import store, { CashFlowStore } from "../services/CashFlowStore";
import GeneralLedgerRiportRowItem, { GeneralLedgerRiportRowItemDefaultProps } from '../models/GeneralLedgerRiportRowItem';
import IconButton from '@/components/IconButton.vue';
import { t } from "@/plugins/i18n";

interface Data {
  store: CashFlowStore;
  newRowItemIndex: number;
  signOptions: object;
}

interface Methods {
  createRiportRowItem(): void;
  removeRiportRowItem(rowItemId: number): void;
}

interface Computed {
  columns: any;
  items: any;
}

interface Props {
  group: Record<string, any>;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    IconButton
  },

  props: {
    group: { type: Object }
  },

  data() {
    return {
      store,
      newRowItemIndex: 0,
      signOptions: [
        { text: "+", value: true },
        { text: "-", value: false }
      ]
    };
  },

  methods: {
    createRiportRowItem() {
      this.newRowItemIndex--;
      this.store.generalLedgerRiportRowItems.unshift({
        ...GeneralLedgerRiportRowItemDefaultProps, 
        id: this.newRowItemIndex, 
        reportRow: this.group.reportRow,
        inEdit: true,
      });
    },
    removeRiportRowItem(rowItemId) {
      this.store.generalLedgerRiportRowItems = this.store.generalLedgerRiportRowItems.filter(rowItem => rowItem.id != rowItemId);
    },
  },

  computed: {
    columns: function() {
      return [
        {
          cell: "command",
          width: "90px"
        },
        {
          field: "sign",
          title: t("Elojel"),
          cell: "sign",
          width: "70px"
        },
        {
          field: "isBalance",
          title: t("CashFlowRiport_EgyenlegSzerepeljen"),
          cell: "isBalance",
          width: "100px"
        },
        {
          field: "isBalanceSign",
          title: t("CashFlowRiport_EgyenlegElojelFigyelese"),
          cell: "isBalanceSign",
          width: "100px"
        },
        {
          field: "accSign",
          title: t("CashFlowRiport_TartozikVagyKovetel"),
          cell: "accSign",
          width: "200px"
        },
        {
          field: "name",
          title: t("Nev"),
          cell: "name",
          width: "150px"
        },
        {
          field: "accNo",
          title: t("FokonyviSzamMaszk"),
          width: "150px",
          cell: "accNo",
          headerClassName: "right_text",
          className: "right_text"
        },
        {
          field: "dimcode1",
          title: t("CashFlowRiport_IDimenzioMaszk"),
          width: "150px",
          cell: "dimcode1",
          headerClassName: "right_text",
          className: "right_text"
        },
        { width: 0 }
      ]
    },

    items() {      
      return this.store.generalLedgerRiportRowItems.filter(item => item.reportRow == this.group.reportRow);
    },
  },
})
